import { z } from 'zod';

/**
 * What the admin finalize accepts: **nothing**.
 *
 * `FinalizeUploadRequest` carries an optional `sortOrder`, which is member
 * vocabulary — the arrangement of one member's photo grid. A platform library
 * has no such arrangement, and the repository call that would write it is
 * owner-scoped, so accepting the field would mean silently ignoring it. An
 * empty `.strict()` object refuses it at the pipe instead; the upload service
 * refuses it again, because a schema protects one route while the service
 * protects every caller.
 */
export const PlatformFinalizeUploadRequestSchema = z.object({}).strict();

export type PlatformFinalizeUploadRequest = z.infer<typeof PlatformFinalizeUploadRequestSchema>;
